import React from 'react';
import {Switch, Route, Redirect, RouteProps, useRouteMatch} from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import AuthenticationPage from '../pages/AuthenticationPage';
import {RoutesPaths, myTheme} from '../environment';
import {isLogin} from '../utils/getSetAccessKey';
import { MuiThemeProvider } from '@material-ui/core/styles';

interface IPrivateRoute extends RouteProps {
  component: React.ComponentClass<any> | React.FunctionComponent<any>
}

const PrivateRoute = ({component: Component, ...rest}: IPrivateRoute) => {
  return (
    <Route {...rest} render={props => (
      isLogin() ?
        <Component {...props} />
        : <Redirect to={RoutesPaths.Auth}/>
    )}/>
  );
};

const AppRouting = () => {
  const matchAuth = useRouteMatch(RoutesPaths.Auth);
  const redirectToLandingPage = isLogin() && !!matchAuth;
  return (
      <MuiThemeProvider theme={myTheme}>
    <Switch>
      {redirectToLandingPage && <Redirect to={RoutesPaths.LandingPage}/>}
      <Route exact path={RoutesPaths.Auth} component={AuthenticationPage}/>
      <PrivateRoute exact path={RoutesPaths.LandingPage} component={LandingPage}/>
      <Route render={() => <Redirect to={RoutesPaths.LandingPage}/>}/>
    </Switch>
      </MuiThemeProvider>
  );
};

export default AppRouting;